var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageScheduleDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.495,
    height: 19.5,
    viewBox: "0 0 19.495 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160661",
    "data-name": "Group 160661",
    transform: "translate(-408.026 -255.585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3235",
    "data-name": "Group 3235",
    transform: "translate(408.776 256.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M18.888,11.354a7.72,7.72,0,0,1-.844,3.536,7.939,7.939,0,0,1-7.1,4.368A7.791,7.791,0,0,1,7.4,18.417L2.08,20.181l1.77-5.3A7.878,7.878,0,0,1,7.389,4.273a7.943,7.943,0,0,1,3.077-.823",
    transform: "translate(-2.08 -2.181)",
    fill: "#adc7ff",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3234",
    "data-name": "Group 3234",
    transform: "translate(6.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M20.252,5.35a5.622,5.622,0,1,1-5.122-3.3,6.059,6.059,0,0,1,2.221.49",
    transform: "translate(-9.51 -2.05)",
    fill: "#f49b31",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M15.8,5.32V8.293h2.23",
    transform: "translate(-10.098 -2.356)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_132",
    "data-name": "Ellipse 132",
    cx: 0.517,
    cy: 0.517,
    r: 0.517,
    transform: "translate(9.02 1.052)",
    fill: "#165cf3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageScheduleDarkIcon);
export default __webpack_public_path__ + "static/media/message-schedule-dark-icon.9805a4841bc5dc43646d183f6fb3a652.svg";
export { ForwardRef as ReactComponent };